module.exports = __webpack_public_path__ + "media/images/avis-4372a1f80aaae5b005c1e51fc868e5df.svg";